import { createRoutine } from "redux-saga-routines";

export const setSignInTimeRoutine = createRoutine('SET_SIGN_IN_TIME');
export const addRunningBallActions = createRoutine('ADD_RB_ACTIONS');
export const addDownloadedSnippetRoutine = createRoutine('ADD_DOWNLOADED_SNIPPET');
export const addDownloadRoutine = createRoutine('ADD_DOWNLOAD');
